/**
 * Route paths for the users feature. The same strings are the sidebar menu keys
 * in `EditUser`.
 */
export const USER_ROUTES = {
  users: "/users",
  add: "/users/add",
  userDetail: "/users/:userId",
  edit: "/users/:userId/edit",
  editInfo: "/users/:userId/edit/info",
  editAccess: "/users/:userId/edit/access",
} as const;

/** Path this tab used to be served from, kept so existing links still work. */
export const LEGACY_EDIT_ACESS_PATH = "/users/:userId/edit/acess";
